module.exports = __webpack_public_path__ + "img/6.b4b1b10b.png";